/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Period_Preset_7dInputs */

const cs_dashboard_period_preset_7d = /** @type {(inputs: Dashboard_Period_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 dní`)
};

const en_dashboard_period_preset_7d = /** @type {(inputs: Dashboard_Period_Preset_7dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 days`)
};

/**
* | output |
* | --- |
* | "7 days" |
*
* @param {Dashboard_Period_Preset_7dInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_period_preset_7d = /** @type {((inputs?: Dashboard_Period_Preset_7dInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Period_Preset_7dInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_period_preset_7d(inputs)
	return cs_dashboard_period_preset_7d(inputs)
});